package org.moxultimate.topwithmox.appscrud.module

import org.koin.dsl.module
import org.moxultimate.topwithmox.appscrud.api.AppsCRUDRepository
import org.moxultimate.topwithmox.appscrud.main.AppsCRUDViewModel

/**
 * appsCRUDModule
 * Koin module for the apps CRUD feature.
 * Reuses HttpClient and AppsRepository singletons registered in appsModule.
 * Registers AppsCRUDRepository and injects both repositories into the ViewModel factory.
 */
val appsCRUDModule = module {

    single {
        AppsCRUDRepository(httpClient = get())
    }

    factory {
        AppsCRUDViewModel(repository = get(), crudRepository = get())
    }
}
